const normalizeFilename = (filename) => {
    const parts = filename.split('.');
    if (parts.length > 1) {
        const extension = parts.pop().toLowerCase();
        return [...parts, extension].join('.');
    }
    return filename;
};

export default normalizeFilename;